// src/services/activity.js
import apiClient from './api';

/**
 * Fetches all activity history for the logged-in user's tenant.
 * Corresponds to: GET /api/activity/
 */
export async function getActivity() {
  const response = await apiClient.get('/activity/');
  return response.data;
}

/**
 * Creates new activity entries.
 * Corresponds to: POST /api/activity/
 */
export async function createActivity(activities) {
  const response = await apiClient.post('/activity/', { activities });
  return response.data;
}

/**
 * Deletes all activity for the logged-in user's tenant.
 * Corresponds to: DELETE /api/activity/
 */
export async function deleteActivity() {
  const response = await apiClient.delete('/activity/');
  return response.data;
}

/**
 * Fetches the activity settings for the tenant.
 * Corresponds to: GET /api/activity/settings
 */
export async function getActivitySettings() {
  const response = await apiClient.get('/activity/settings');
  return response.data;
}

/**
 * Updates the activity settings for the tenant.
 * Corresponds to: PUT /api/activity/settings
 */
export async function updateActivitySettings(deletionTimeout) {
  const response = await apiClient.put('/activity/settings', { deletionTimeout });
  return response.data;
}
